import React from 'react';

/**
 * Convert URLs and emails in text to clickable links
 * @param text - The text to process
 * @param linkClassName - Optional CSS class for links (defaults to inline blue style)
 * @returns Array of React nodes with URLs/emails converted to anchor tags
 */
export function linkifyText(text: string, linkClassName?: string): React.ReactNode[] {
  if (!text) return [];

  // Combined regex for URLs and emails
  const linkRegex = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
  const parts = text.split(linkRegex);

  return parts.map((part, index) => {
    const key = `${part}-${index}`;
    // Check if it's a URL
    if (/^https?:\/\//i.test(part)) {
      return (
        <a
          key={key}
          href={part}
          target="_blank"
          rel="noreferrer nofollow"
          className={linkClassName || 'linkified-url'}
          style={linkClassName ? undefined : { color: '#0066cc', textDecoration: 'underline' }}
        >
          {part}
        </a>
      );
    }
    // Check if it's an email
    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(part)) {
      return (
        <a
          key={key}
          href={`mailto:${part}`}
          className={linkClassName || 'linkified-email'}
          style={linkClassName ? undefined : { color: '#0066cc', textDecoration: 'underline' }}
        >
          {part}
        </a>
      );
    }
    return part;
  });
}
